import React from 'react';
import ProductOverview from '../../product-overview/ProductOverview';
import product from '../all-gear.json';

const WomensAdidasPerformanceShirt = () => {
	return (
		<React.Fragment>
			<ProductOverview
				name={product.allGear[18].productName}
				color={product.allGear[18].color}
				size={product.allGear[18].sizes}
				price={product.allGear[18].price}
				img={product.allGear[18].img}
				miniImg1={product.allGear[18].miniImg1}
				miniImg2={product.allGear[18].miniImg2}
				miniImg3={product.allGear[18].miniImg3}
			/>
		</React.Fragment>
	);
};

export default WomensAdidasPerformanceShirt;
